import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../utils/hooks/useMutationWithError";
import { useCreateEmailVerificationMutation } from "./__generated__/useCreateEmailVerificationMutation.graphql";

export const useCreateEmailVerification = () => {
  const [createVerification, isCreating] =
    useMutationWithError<useCreateEmailVerificationMutation>(
      userCheckPhoneMutationString
    );

  const createEmailVerification = (
    email: string,
    onCompleteHandler: () => void
  ) => {
    createVerification({
      variables: { input: { email } },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleteHandler();
        }
      },
    });
  };
  return [createEmailVerification, isCreating] as const;
};

export const userCheckPhoneMutationString = graphql`
  mutation useCreateEmailVerificationMutation(
    $input: CreateEmailVerificationInput!
  ) {
    responsePayload: createEmailVerification(input: $input) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
